module.exports = __webpack_public_path__ + "img/people_sz.c39e74b0.png";